import { Scenario, getExternalTouchpointParameters, getSourceId } from '@account/account-portal/config'
import { SocialLoginProvider, startExternalAuthFlow } from '@account/account-portal/external-auth'
import { Touchpoint } from '@account/account-portal/lib'
import { GlButton } from '@adl/component-button'
import { useDevice } from '@crystal/core'
import { FC, useState } from 'react'

import { useConsents, useViewData } from '../lib'

export type SocialLoginButtonProps = {
  providerId: SocialLoginProvider
  displayName?: string
  persistentLogin?: boolean
  compactButtons?: boolean
  fullWidthButtons?: boolean
  analytics?: {
    originLocation?: string
  }
  className?: string
}

export const SocialLoginButton: FC<SocialLoginButtonProps> = ({
  providerId,
  displayName,
  compactButtons,
  fullWidthButtons,
  persistentLogin,
  analytics: { originLocation } = {},
  className,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const { isMobile } = useDevice()
  const { viewData } = useViewData()
  const consentType = 'registration'
  const consents = useConsents(consentType)
  const title = displayName || providerId
  const consentPayload = {
    ...(consents?.isValid && { legalAcceptance: consents?.payload.legalAcceptance }),
  }

  const initiateSocialLogin = () => {
    const touchpoint = viewData.touchpoint || Touchpoint.Unknown
    const sourceId = getSourceId(touchpoint, Scenario.Registration)
    const touchpointParams = getExternalTouchpointParameters()
    setIsLoading(true)
    startExternalAuthFlow({
      method: 'social-login',
      provider: providerId,
      authContext: {
        persistentLogin,
        originLocation,
        sourceId: touchpointParams?.sourceId || sourceId,
        storeId: touchpointParams?.storeId,
      },
      transitData: {
        legalAcceptance: consentPayload.legalAcceptance,
      },
    })
  }

  return (
    <GlButton
      onClick={initiateSocialLogin}
      variant="secondary"
      icon={providerId}
      id={`social-button-${providerId}`}
      aria-label={`Login with ${providerId}`}
      fullWidth={isMobile || fullWidthButtons}
      className={`${!compactButtons && !fullWidthButtons ? 'gl-vspace-bpall-small' : ''} ${className ?? ''}`}
      loading={isLoading}
      disabled={isLoading}>
      {!compactButtons && title}
    </GlButton>
  )
}
